export default __webpack_public_path__ + "static/N0223-35020228f6d13f6e9e7288c5ce2cb8f0.png";